import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  codeGrid: {
    marginRight: theme.spacing(0.5),
  },
  label: {
    color: '#4D5365',
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px', /* 150% */
  },
  asterisk: {
    color: '#BC1616',
  },
  select: {
    height: '40px',
    '&.Mui-error': {
      '& .am-MuiOutlinedInput-notchedOutline': {
        borderColor: '#BC1616 !important',
      },
    },
  },
  input: {
    paddingTop: theme.spacing(1.1875),
    paddingBottom: theme.spacing(1.1875),
    textAlign: 'left',
  },
  menuList: {
    minHeight: theme.spacing(6),
    maxHeight: theme.spacing(68.75),
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
  },
  error: {
    color: '#BC1616',
    fontFamily: 'Noto Sans',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px', /* 150% */
  },
}));
